import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TcButton from '../components/TcButton';
import TcPaper from '../components/TcPaper';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { setUserProfile } from '../store/slices/userSlice';
import { useScrollToBottom } from '../hooks/useScrollToBottom';
import { useDeviceDetection } from '../hooks/useDeviceDetection';
import { trackRegistration } from "../utils/eventTracking";


export default function PrivacyPolicy() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { orientation } = useDeviceDetection();
    const isLandscape = orientation === 'landscape';
    const { language } = useAppSelector(state => state.user);

    // Use the custom hook for scroll detection
    const isAtBottom = useScrollToBottom({
        containerSelector: '.main-content-wrapper'
    });

    const handleAccept = () => {
        dispatch(setUserProfile({ privacyAccepted: true }));
        navigate('/register');
    };

    const handleSkipPersonalization = () => {
        dispatch(setUserProfile({ privacyAccepted: false, ageGroup: '', nationality: '' }));
        trackRegistration(false, false, {
            language,
            ageGroup: '',
            nationality: ''
        }).then(() => {});

        navigate('/ready-to-explore');
    };

    return (
        <div className={`
            main-content-wrapper bg-image-galaxy 
            ${isLandscape ? '!pt-8' : '!pt-[112px]'} 
            unselectable 
            has-transition 
        `}>
            <TcPaper classNameStyle="mt-6 mb-4">
                <h1 className="main-content-title"
                    dangerouslySetInnerHTML={{ __html: t('privacy.title') }}
                />
            </TcPaper>

            <TcPaper classNameStyle="general-content mb-0">
                <p
                    className="main-content-subtitle mb-6"
                    dangerouslySetInnerHTML={{ __html: t('privacy.subtitle') }}
                    />

                <div className={`
                    text-sm bg-white bg-opacity-90 rounded-xl 
                    p-4 mx-auto mb-8 
                    max-w-lg max-h-[40vh] 
                    h-[40vh] 2xs:h-[20vh] xs:h-[25vh] sm:h-[30vh] md:h-[40vh] 
                    overflow-y-auto 
                    shadow-md 
                    border border-gray-200 
                `}>
                    <div
                        className="text-neutral-950 text-left"
                        dangerouslySetInnerHTML={{ __html: t('privacy.policyText') }}
                        />
                </div>

                <div className={`button-wrapper stick-to-bottom p-4 !bottom-[4vw] !max-w-[92vw] has-transition ${
                    isAtBottom ? 'clear-transparent' : 'glossy-translucent-with-border'
                }`}>
                    <TcButton
                        classNameStyle={`max-w-lg`}
                        handleClick={handleAccept}
                        primary
                    >
                        {t('privacy.acceptButton')}
                    </TcButton>

                    <div className="mt-4 max-w-lg mx-auto">
                        <button
                            onClick={handleSkipPersonalization}
                            className="text-white hover:text-gray-200 py-2 text-base"
                        >
                            {t('privacy.skipButton')}
                        </button>
                    </div>
                </div>
            </TcPaper>
        </div>
    );
} 